import script from "./GoogleSignInButton.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleSignInButton.vue?vue&type=script&setup=true&lang=js"

import "./GoogleSignInButton.vue?vue&type=style&index=0&id=e8fa56c8&lang=css"

const __exports__ = script;

export default __exports__